import { useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export default function Design() {
    const [emailEnabled, setEmailEnabled] = useState(true);
    const [smsEnabled, setSmsEnabled] = useState(false);
    const [subject, setSubject] = useState('Important announcement from karan');
    const [editorState, setEditorState] = useState(() => {
        const contentState = EditorState.createEmpty();
        return EditorState.moveFocusToEnd(
            EditorState.push(contentState, contentState.getCurrentContent())
        );
    });

    const onEditorStateChange = (newEditorState) => {
        setEditorState(newEditorState);
    };
    return (
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-6 gap-6">
            {/* Left Panel - 2 columns */}
            <div className="lg:col-span-2 h-[270px] bg-theme_clr1 text-white rounded-xl p-8 shadow-md">
                <h2 className="text-2xl font-bold mb-3">Create your Message</h2>
                <p className="text-white/90 mb-8 leading-relaxed">
                    Directly reach out to your fans with a customized email blast.
                </p>

                {/* Toggle Options */}
                <div className="space-y-5">
                    <div className="flex items-center">
                        <button
                            onClick={() => setEmailEnabled(!emailEnabled)}
                            className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors ${emailEnabled ? 'bg-[#FF6B54]' : 'bg-white/30'
                                }`}
                        >
                            <span
                                className={`inline-block h-6 w-6 transform rounded-full bg-white transition-transform ${emailEnabled ? 'translate-x-7' : 'translate-x-1'
                                    }`}
                            />
                        </button>
                        <span className="ml-4 text-base font-medium">Send via Email</span>
                    </div>

                    <div className="flex items-center">
                        <button
                            onClick={() => setSmsEnabled(!smsEnabled)}
                            className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors ${smsEnabled ? 'bg-[#FF6B54]' : 'bg-white/30'
                                }`}
                        >
                            <span
                                className={`inline-block h-6 w-6 transform rounded-full bg-white transition-transform ${smsEnabled ? 'translate-x-7' : 'translate-x-1'
                                    }`}
                            />
                        </button>
                        <span className="ml-4 text-base font-medium">Send via SMS</span>
                    </div>
                </div>
            </div>

            {/* Right Panel - 3 columns */}
            <div className="lg:col-span-4 bg-white rounded-xl border border-theme_clr1 overflow-hidden shadow-md">
                <div className="bg-white text-theme_clr1 border-b-2 border-theme_clr2 w-36 px-2 py-1">
                    <h3 className="text-md font-normal">Email Messages</h3>
                </div>

                <div className="bg-theme_clr1 p-3">
                    {/* Subject Line */}
                    <div className="mb-4 w-full">
                        <div className="flex items-center gap-3 w-full">
                            <span className="text-white font-bold text-sm whitespace-nowrap">
                                Subject Line:
                            </span>

                            {/* Input Wrapper */}
                            <div className="flex-grow">
                                <input
                                    type="text"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    className="w-full pl-4 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#0000B3] text-sm"
                                    placeholder="Enter subject line"
                                />
                            </div>

                            {/* Button */}
                            <button className="bg-theme_clr2 text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#FF5540] transition-colors text-sm whitespace-nowrap">
                                Send Preview
                            </button>
                        </div>
                    </div>


                    {/* Rich Text Editor with Draft.js */}
                    <div className="rounded-lg min-h-[200px] flex flex-col">
                        <div className="bg-white rounded-xl shadow-sm flex-1 overflow-hidden draft-editor-wrapper">
                            <style>{`
                      .draft-editor-wrapper .rdw-editor-toolbar {
                        background: #FF6B54;
                        border: none;
                        border-radius: 12px 12px 0 0;
                        padding: 10px;
                        margin-bottom: 0;
                      }
                      .draft-editor-wrapper .rdw-option-wrapper {
                        background: white;
                        border: none;
                        border-radius: 4px;
                        min-width: 32px;
                        height: 32px;
                        margin: 0 2px;
                        transition: all 0.2s;
                      }
                      .draft-editor-wrapper .rdw-option-wrapper:hover {
                        background: #f3f4f6;
                        box-shadow: none;
                      }
                      .draft-editor-wrapper .rdw-option-active {
                        background: #0000B3 !important;
                        box-shadow: none;
                      }
                      .draft-editor-wrapper .rdw-option-active img {
                        filter: brightness(0) invert(1);
                      }
                      .draft-editor-wrapper .rdw-dropdown-wrapper {
                        background: white;
                        border: none;
                        border-radius: 4px;
                        height: 32px;
                        margin: 0 2px;
                      }
                      .draft-editor-wrapper .rdw-dropdown-optionwrapper {
                        background: white;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                      }
                      .draft-editor-wrapper .rdw-dropdownoption-default {
                        transition: background 0.2s;
                      }
                      .draft-editor-wrapper .rdw-dropdownoption-default:hover {
                        background: #f3f4f6;
                      }
                      .draft-editor-wrapper .rdw-dropdownoption-active {
                        background: #0000B3;
                        color: white;
                      }
                      .draft-editor-wrapper .rdw-editor-main {
                        padding: 10px;
                        min-height: 70px;
                        font-size: 16px;
                        color: #0000B3;
                        background: white;
                      }
                      .draft-editor-wrapper .public-DraftEditor-content {
                        min-height: 70px;
                      }
                      .draft-editor-wrapper .public-DraftEditorPlaceholder-root {
                        color: #9ca3af;
                      }
                      .draft-editor-wrapper .rdw-link-modal {
                        background: white;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
                      }
                      .draft-editor-wrapper .rdw-link-modal-btn {
                        background: #FF6B54;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        padding: 6px 12px;
                        cursor: pointer;
                      }
                      .draft-editor-wrapper .rdw-link-modal-btn:hover {
                        background: #FF5540;
                      }
                      .draft-editor-wrapper .rdw-link-modal-btn:disabled {
                        background: #d1d5db;
                      }
                      .draft-editor-wrapper .rdw-embedded-modal {
                        background: white;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
                        border-radius: 8px;
                      }
                      .draft-editor-wrapper .rdw-embedded-modal-header {
                        border-bottom: 1px solid #e5e7eb;
                      }
                      .draft-editor-wrapper .rdw-embedded-modal-btn {
                        background: #FF6B54;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        padding: 6px 12px;
                        cursor: pointer;
                      }
                      .draft-editor-wrapper .rdw-embedded-modal-btn:hover {
                        background: #FF5540;
                      }
                      .draft-editor-wrapper .rdw-embedded-modal-btn:disabled {
                        background: #d1d5db;
                      }
                      .draft-editor-wrapper .rdw-image-modal {
                        background: white;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
                        border-radius: 8px;
                        left: -150px;
                      }
                      .draft-editor-wrapper .rdw-image-modal-header {
                        border-bottom: 1px solid #e5e7eb;
                        padding: 12px;
                        font-weight: 600;
                      }
                      .draft-editor-wrapper .rdw-image-modal-upload-option,
                      .draft-editor-wrapper .rdw-image-modal-url-section {
                        padding: 12px;
                      }
                      .draft-editor-wrapper .rdw-image-modal-url-input {
                        width: 100%;
                        padding: 8px;
                        border: 1px solid #e5e7eb;
                        border-radius: 4px;
                        margin: 8px 0;
                      }
                      .draft-editor-wrapper .rdw-image-modal-btn {
                        background: #FF6B54;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        padding: 8px 16px;
                        cursor: pointer;
                        margin: 4px;
                      }
                      .draft-editor-wrapper .rdw-image-modal-btn:hover {
                        background: #FF5540;
                      }
                      .draft-editor-wrapper .rdw-image-modal-btn:disabled {
                        background: #d1d5db;
                        cursor: not-allowed;
                      }
                      .draft-editor-wrapper .rdw-image-modal-size {
                        display: flex;
                        gap: 8px;
                        margin: 8px 0;
                      }
                      .draft-editor-wrapper .rdw-image-modal-size-input {
                        width: 60px;
                        padding: 6px;
                        border: 1px solid #e5e7eb;
                        border-radius: 4px;
                      }
                      .draft-editor-wrapper .rdw-link-modal {
                        background: white;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
                        border-radius: 8px;
                        padding: 16px;
                        height: auto;
                        left: -100px;
                      }
                      .draft-editor-wrapper .rdw-link-modal-label {
                        font-size: 14px;
                        margin-bottom: 6px;
                        display: block;
                        color: #374151;
                      }
                      .draft-editor-wrapper .rdw-link-modal-input {
                        width: 100%;
                        padding: 8px;
                        border: 1px solid #e5e7eb;
                        border-radius: 4px;
                        margin-bottom: 12px;
                        font-size: 14px;
                      }
                      .draft-editor-wrapper .rdw-link-modal-target-option {
                        margin: 8px 0;
                      }
                      .draft-editor-wrapper .rdw-link-modal-target-option input {
                        margin-right: 6px;
                      }
                      .draft-editor-wrapper .rdw-link-modal-buttonsection {
                        display: flex;
                        justify-content: flex-end;
                        gap: 8px;
                        margin-top: 12px;
                      }
                      .draft-editor-wrapper .rdw-link-modal-btn {
                        background: #FF6B54;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        padding: 8px 16px;
                        cursor: pointer;
                        font-size: 14px;
                      }
                      .draft-editor-wrapper .rdw-link-modal-btn:hover {
                        background: #FF5540;
                      }
                    `}</style>
                            <Editor
                                editorState={editorState}
                                onEditorStateChange={onEditorStateChange}
                                placeholder="Hey this is karan, I wanted to tell you about..."
                                toolbar={{
                                    options: ['inline', 'link', 'image', 'fontSize', 'fontFamily', 'textAlign'],
                                    inline: {
                                        inDropdown: false,
                                        options: ['bold', 'italic', 'underline', 'strikethrough'],
                                    },
                                    fontSize: {
                                        icon: undefined,
                                        options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                                        className: undefined,
                                        component: undefined,
                                        dropdownClassName: undefined,
                                    },
                                    fontFamily: {
                                        options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'Comic Sans MS', 'Courier New'],
                                        className: undefined,
                                        component: undefined,
                                        dropdownClassName: undefined,
                                    },
                                    textAlign: {
                                        inDropdown: false,
                                        options: ['left', 'center', 'right', 'justify'],
                                    },
                                    link: {
                                        inDropdown: false,
                                        className: undefined,
                                        component: undefined,
                                        popupClassName: undefined,
                                        dropdownClassName: undefined,
                                        showOpenOptionOnHover: true,
                                        defaultTargetOption: '_self',
                                        options: ['link', 'unlink'],
                                        linkCallback: undefined
                                    },
                                    image: {
                                        icon: undefined,
                                        className: undefined,
                                        component: undefined,
                                        popupClassName: undefined,
                                        urlEnabled: true,
                                        uploadEnabled: true,
                                        alignmentEnabled: true,
                                        uploadCallback: undefined,
                                        previewImage: false,
                                        inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                        alt: { present: false, mandatory: false },
                                        defaultSize: {
                                            height: 'auto',
                                            width: 'auto',
                                        },
                                    },
                                }}
                            />
                        </div>
                        <div className="flex items-center justify-center gap-3 mt-6">
                            <img
                                src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100&h=100&fit=crop"
                                alt="karan"
                                className="w-9 h-9 rounded-full border-2 border-white"
                            />
                            <span className="text-white font-medium text-base">karan</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}